import React from 'react';
import { styled } from '@mui/material/styles';
import Grow from '@mui/material/Grow';
import Alert from '@mui/material/Alert';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslate } from '@im/react-localization';

type AlertObject = {
  messageKey: string;
  showAlert: boolean;
};
type AlertBoxProps = {
  alert: {
    messageKey: string;
    showAlert: boolean;
  };
  setalert: (alert: AlertObject) => void;
};

export default function AlertBox(props: AlertBoxProps) {
  //Translate parameter
  const translate = useTranslate();
  const { alert, setalert } = props;
  const handleClose = () => {
    setalert({
      messageKey: '',
      showAlert: false,
    });
  };

  return (
    <>
      {alert.messageKey && (
        <Grow in={alert.showAlert}>
          <StyledAlert
            icon={
              alert.messageKey === 'success' ? (
                <CheckCircleOutlineIcon />
              ) : (
                <ErrorOutlineOutlinedIcon />
              )
            }
            onClose={handleClose}
            severity={alert.messageKey === 'success' ? 'success' : 'error'}
            variant="filled"
          >
            {translate(alert.messageKey)}
          </StyledAlert>
        </Grow>
      )}
    </>
  );
}

const StyledAlert = styled(Alert)(({ theme }) => ({
  height: 'auto',
  left: '25%',
  margin: '0 auto',
  maxWidth: '80%',
  minWidth: 'auto',
  padding: '0 14px',
  position: 'absolute',
  textAlign: 'center',
  top: '12px',
  width: 'auto',
  wordBreak: 'break-word',
}));
